// The tiers are named the same across all locales
export const TiersMap = {
    starter: 'Starter',
    essential: 'Essential',
    advanced: 'Advanced',
    beyond: 'Beyond',
} as const
